var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},_vm._l((2),function(k){return _c('v-col',{key:k,attrs:{"cols":"3"}},[_c('v-sheet',{staticClass:"pa-2 ma-2"})],1)}),1),_c('div',{staticClass:"d-flex justify-center small font-xs"},[_vm._v(" Copyright © 2022 Houston株式会社 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }